export default () => [
  {
    field: 'transferSeqno',
    headerAlign: 'center',
    align: 'center',
    width: 150,
    title: '执行顺序',
    showOverflow: 'ellipsis',
  },
  {
    field: 'transferStationName',
    headerAlign: 'center',
    align: 'center',
    width: 150,
    title: '中转站名称',
    showOverflow: 'ellipsis',
  },
  {
    field: 'bizTypeName',
    headerAlign: 'center',
    align: 'center',
    width: 150,
    title: '业务类型',
    showOverflow: 'ellipsis',
  },

  // {
  //   field: 'transportMode',
  //   headerAlign: 'center',
  //   align: 'left',
  //   width: 150,
  //   title: '运输模式',
  //   showOverflow: 'ellipsis'
  // },
  {
    field: 'contactName',
    headerAlign: 'center',
    align: 'center',
    width: 150,
    title: '联系人姓名',
    showOverflow: 'ellipsis',
  },
  {
    field: 'contactMobile',
    headerAlign: 'center',
    align: 'center',
    width: 150,
    title: '联系人手机',
    showOverflow: 'ellipsis',
  },
  {
    field: 'transferStationAddress',
    headerAlign: 'center',
    align: 'left',
    width: 200,
    title: '中转站地址',
    showOverflow: 'ellipsis',
  },
  {
    field: 'uploadReceiptFlag',
    headerAlign: 'center',
    align: 'center',
    width: 120,
    title: '是否上传回单',
    editRender: {
      name: 'select',
      options: [
        {label: '需要上传', value: 'Y'},
        {label: '不需要上传', value: 'N'},
      ],
    },
  },
  // {
  //   field: 'receiveDatetimeBegin',
  //   headerAlign: 'center',
  //   align: 'left',
  //   width: 150,
  //   title: '预计到达时间',
  //   slots: {
  //     default: 'receiveDatetime',
  //   },
  //   showOverflow: 'ellipsis'
  // },
  // {
  //   field: 'outDatetimeBegin',
  //   headerAlign: 'center',
  //   align: 'left',
  //   width: 150,
  //   title: '预计发出时间',
  //   slots: {
  //     default: 'outDatetime',
  //   },
  //   showOverflow: 'ellipsis'
  // },
]
